import React from 'react';
import { Typography, Row, Col, Form, Input, Button, Card, Space, Divider } from 'antd';
import { 
  MailOutlined, 
  PhoneOutlined, 
  EnvironmentOutlined,
  MessageOutlined,
  UserOutlined,
  TeamOutlined 
} from '@ant-design/icons';

const { Title, Paragraph, Text } = Typography;
const { TextArea } = Input;

const Contact = () => {
  const [form] = Form.useForm();

  const onFinish = (values) => {
    console.log('Received values:', values);
    // Ici, vous implémenteriez la logique d'envoi du formulaire
    // Par exemple, un appel API vers votre backend
    
    // Réinitialiser le formulaire après soumission
    form.resetFields();
    
    // Afficher un message de succès (dans une implémentation réelle)
    // message.success('Votre message a été envoyé avec succès !');
  };

  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="bg-gradient-to-r from-blue-600 to-blue-400 text-white py-16">
        <div className="container mx-auto px-4 text-center">
          <Title level={1} className="text-white mb-6">
            Contactez-nous
          </Title>
          <Paragraph className="text-lg opacity-90 max-w-2xl mx-auto">
            Notre équipe est à votre disposition pour répondre à toutes vos questions
            et vous accompagner dans votre projet.
          </Paragraph>
        </div>
      </section>

      {/* Formulaire de contact et informations */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <Row gutter={[48, 48]}>
            <Col xs={24} lg={14}>
              <Card className="shadow-lg h-full">
                <Title level={2} className="mb-8">
                  Envoyez-nous un message
                </Title>
                <Form
                  form={form}
                  name="contact"
                  layout="vertical"
                  onFinish={onFinish}
                  scrollToFirstError
                >
                  <Row gutter={16}>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="name"
                        label="Nom complet"
                        rules={[{ required: true, message: 'Veuillez saisir votre nom' }]}
                      >
                        <Input prefix={<UserOutlined />} placeholder="Votre nom" size="large" />
                      </Form.Item>
                    </Col>
                    <Col xs={24} sm={12}>
                      <Form.Item
                        name="email"
                        label="Email"
                        rules={[
                          { required: true, message: 'Veuillez saisir votre email' },
                          { type: 'email', message: 'Email invalide' }
                        ]}
                      >
                        <Input prefix={<MailOutlined />} placeholder="Votre email" size="large" />
                      </Form.Item>
                    </Col>
                  </Row>

                  <Form.Item
                    name="phone"
                    label="Téléphone"
                  >
                    <Input prefix={<PhoneOutlined />} placeholder="Votre numéro de téléphone" size="large" />
                  </Form.Item>

                  <Form.Item
                    name="subject"
                    label="Sujet"
                    rules={[{ required: true, message: 'Veuillez saisir un sujet' }]}
                  >
                    <Input placeholder="Sujet de votre message" size="large" />
                  </Form.Item>

                  <Form.Item
                    name="message"
                    label="Message"
                    rules={[{ required: true, message: 'Veuillez saisir votre message' }]}
                  >
                    <TextArea 
                      placeholder="Votre message..." 
                      rows={6} 
                      size="large"
                    />
                  </Form.Item>

                  <Form.Item>
                    <Button type="primary" htmlType="submit" size="large" block shape="round">
                      Envoyer le message
                    </Button>
                  </Form.Item>
                </Form>
              </Card>
            </Col>
            
            <Col xs={24} lg={10}>
              <Card className="shadow-lg h-full bg-blue-50">
                <Title level={2} className="mb-8">
                  Nos coordonnées
                </Title>
                
                <Space direction="vertical" size="large" className="w-full">
                  <div className="flex items-start">
                    <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0">
                      <MailOutlined style={{ fontSize: 20 }} />
                    </div>
                    <div>
                      <Text strong className="text-lg block mb-1">Email</Text>
                      <a href="mailto:contact@wabot.com" className="text-blue-500 hover:text-blue-700">
                        contact@wabot.com
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0">
                      <PhoneOutlined style={{ fontSize: 20 }} />
                    </div>
                    <div>
                      <Text strong className="text-lg block mb-1">Téléphone</Text>
                      <a href="tel:+221771234567" className="text-blue-500 hover:text-blue-700">
                        +221 77 123 45 67
                      </a>
                    </div>
                  </div>
                  
                  <div className="flex items-start">
                    <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0">
                      <EnvironmentOutlined style={{ fontSize: 20 }} />
                    </div>
                    <div>
                      <Text strong className="text-lg block mb-1">Adresse</Text>
                      <address className="not-italic">
                        Boulevard de la République<br />
                        Immeuble Azur, 4ème étage<br />
                        Dakar, Sénégal
                      </address>
                    </div>
                  </div>
                </Space>

                <Divider />
                
                <Title level={3} className="mb-4">
                  Heures d'ouverture
                </Title>
                <ul className="list-none p-0 space-y-2">
                  <li className="flex justify-between">
                    <span>Lundi - Vendredi:</span>
                    <strong>08:00 - 18:00</strong>
                  </li>
                  <li className="flex justify-between">
                    <span>Samedi:</span>
                    <strong>09:00 - 13:00</strong>
                  </li>
                  <li className="flex justify-between">
                    <span>Dimanche:</span>
                    <strong>Fermé</strong>
                  </li>
                </ul>

                <Divider />
                
                <Title level={3} className="mb-4">
                  Support technique
                </Title>
                <Paragraph>
                  Notre équipe technique est disponible du lundi au vendredi de 08:00 à 20:00.
                </Paragraph>
                <a href="mailto:support@wabot.com" className="text-blue-500 hover:text-blue-700">
                  support@wabot.com
                </a>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Section FAQ rapide */}
      <section className="py-16 bg-gray-50">
        <div className="container mx-auto px-4">
          <Title level={2} className="text-center mb-12">
            Questions fréquentes
          </Title>
          
          <Row gutter={[32, 32]}>
            <Col xs={24} md={8}>
              <Card className="h-full shadow-md">
                <div className="flex items-start mb-4">
                  <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0">
                    <MessageOutlined style={{ fontSize: 20 }} />
                  </div>
                  <div>
                    <Title level={4}>Comment puis-je démarrer avec WABot ?</Title>
                  </div>
                </div>
                <Paragraph>
                  Pour commencer, inscrivez-vous à l'essai gratuit de 14 jours. Vous pourrez connecter 
                  votre numéro WhatsApp et configurer les premières réponses automatiques en quelques minutes.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={8}>
              <Card className="h-full shadow-md">
                <div className="flex items-start mb-4">
                  <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0">
                    <TeamOutlined style={{ fontSize: 20 }} />
                  </div>
                  <div>
                    <Title level={4}>Proposez-vous une démonstration ?</Title>
                  </div>
                </div>
                <Paragraph>
                  Oui, nous proposons des démonstrations personnalisées pour les entreprises 
                  qui souhaitent explorer WABot en profondeur. Contactez notre équipe commerciale 
                  pour planifier une session.
                </Paragraph>
              </Card>
            </Col>
            
            <Col xs={24} md={8}>
              <Card className="h-full shadow-md">
                <div className="flex items-start mb-4">
                  <div className="bg-blue-100 text-blue-600 rounded-full w-12 h-12 flex items-center justify-center mr-4 flex-shrink-0">
                    <UserOutlined style={{ fontSize: 20 }} />
                  </div>
                  <div>
                    <Title level={4}>Puis-je migrer depuis une autre solution ?</Title>
                  </div>
                </div>
                <Paragraph>
                  Absolument ! Notre équipe vous accompagne dans la migration depuis d'autres 
                  plateformes. Nous assurons une transition en douceur sans perturber vos communications clients.
                </Paragraph>
              </Card>
            </Col>
          </Row>
        </div>
      </section>

      {/* Google Map Section (placeholder) */}
      <section className="h-96 bg-gray-200 flex items-center justify-center">
        <div className="text-center">
          <Title level={3} className="m-0">Carte Google Maps</Title>
          <Paragraph className="mb-0">
            Ici serait intégrée une carte Google Maps montrant l'emplacement de vos bureaux
          </Paragraph>
        </div>
      </section>
    </div>
  );
};

export default Contact; 